import React, { FC, memo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { WaitingButton, Description, Checkbox } from "@evergis/ui";

import { Link } from "components/styled/links/Link";
import { ButtonsContainer, ErrorMessage } from "components/styled/forms";
import { CheckboxesContainer, Desc } from "./styled";

import { ROUTES } from "../../appConfig";

import { isEmpty } from "../../utils/object";
import { getPortalConfigSelector } from "../../ducks/portalConfig";
import { getMarkdownString } from "../../utils/string";
import { useRegFormSettings } from "../../hooks/useRegFormSettings";

import { IFormFooterProps, IValues } from "./types";

const FormFooterComponent: FC<IFormFooterProps> = ({
  values = {
    email: "",
    username: "",
    password1: "",
    password2: "",
  } as Partial<IValues>,
  error,
  errors,
  isUsernameUnique,
  isEmailUnique,
  isWaiting,
  isSubscribed,
  send,
  toggleSubscribed,
  isTermsAccepted,
  toggleTermsAccepted,
}) => {
  const { t } = useTranslation();
  const config = useSelector(getPortalConfigSelector);
  const { email, username, password1, password2 } = values;
  const { signIn, terms } = useRegFormSettings();

  if (!config) {
    return null;
  }

  return (
    <>
      <CheckboxesContainer style={{ marginTop: "1rem" }}>
        <Checkbox name="is_subscribed" checked={isSubscribed} onChange={toggleSubscribed} />
        <Desc>Получать рассылку</Desc>
      </CheckboxesContainer>
      <CheckboxesContainer>
        <Checkbox name="is_terms_accepted" checked={isTermsAccepted} onChange={toggleTermsAccepted} />
        <Desc dangerouslySetInnerHTML={{ __html: getMarkdownString(terms) }} />
      </CheckboxesContainer>
      <ButtonsContainer style={{ marginTop: "1.5rem" }}>
        <Link to={ROUTES.SIGN_IN}>{signIn}</Link>
        <WaitingButton
          isWaiting={isWaiting}
          primary
          className="primary-button"
          disabled={
            !isEmpty(errors) ||
            !isUsernameUnique ||
            !isEmailUnique ||
            !isTermsAccepted ||
            username === "" ||
            email === "" ||
            password1 === "" ||
            password2 === ""
          }
          onClick={send}
        >
          {t("register")}
        </WaitingButton>
      </ButtonsContainer>
      {((error.email && error.email[0]) || error.none_field_errors || error.other) && (
        <ErrorMessage>
          <Description style={{ margin: 0 }}>
            {error.email || error.none_field_errors || error.other}
            {error.email && error.email[0] && (
              <Link to={ROUTES.ACCESS_RECOVERY}>
                <Description style={{ marginBottom: 0 }}> {t("forgotLoginPassword")}</Description>
              </Link>
            )}
          </Description>
        </ErrorMessage>
      )}
    </>
  );
};

export const FormFooter = memo(FormFooterComponent);
